export const calculateAllowedDomainErrorMessage = (isValid: boolean) =>
  isValid ? undefined : 'Must be a domain like site1.com';
